import * as _ from 'lodash';
import { DropdownOption } from '../../definitions/formItem/ElementConfig';
var ProductLine = /** @class */ (function () {
    function ProductLine(obj, id) {
        if (id) {
            this.id = id;
        }
        this.bg_name = obj.bg_name;
        this.en_name = obj.en_name;
        if (obj.position) {
            this.position = obj.position;
        }
        if (obj.products) {
            this.product_ids = this.getProductsIds(obj.products);
            this.products_formatted = this.getProductsFormatted(obj.products);
        }
    }
    ProductLine.prototype.getProductsIds = function (rawProducts) {
        var ids = [];
        for (var _i = 0, rawProducts_1 = rawProducts; _i < rawProducts_1.length; _i++) {
            var prod = rawProducts_1[_i];
            ids.push(Number(prod.value));
        }
        return ids;
    };
    ProductLine.prototype.getProductsFormatted = function (rawProducts) {
        var ids = [];
        for (var _i = 0, rawProducts_2 = rawProducts; _i < rawProducts_2.length; _i++) {
            var prod = rawProducts_2[_i];
            ids.push(new DropdownOption({
                label: _.get(prod, 'attributes.name'),
                value: _.get(prod, 'id'),
            }));
        }
        return ids;
    };
    Object.defineProperty(ProductLine.prototype, "Id", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductLine.prototype, "BgName", {
        get: function () {
            return this.bg_name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductLine.prototype, "EnName", {
        get: function () {
            return this.en_name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductLine.prototype, "Position", {
        get: function () {
            return this.position;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductLine.prototype, "Products", {
        get: function () {
            return this.product_ids;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductLine.prototype, "ProductsFormatted", {
        get: function () {
            return this.products_formatted;
        },
        enumerable: false,
        configurable: true
    });
    return ProductLine;
}());
export { ProductLine };
export function createProductLine(obj, id) {
    return new ProductLine(obj, id);
}
export function createProductLines(rawProductLines) {
    var productLines = [];
    var rawProductLinesData = rawProductLines.data;
    for (var _i = 0, rawProductLinesData_1 = rawProductLinesData; _i < rawProductLinesData_1.length; _i++) {
        var rawProductLine = rawProductLinesData_1[_i];
        var productLine = createProductLine(rawProductLine.attributes, rawProductLine.id);
        productLines.push(productLine);
    }
    return productLines;
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/brand/productLine.ts
// module id = 141
// module chunks = 0